var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c("el-input", {
        attrs: { disabled: _vm.disabled, type: "textarea", rows: 5 },
        model: {
          value: _vm.cargoDoc.portRequirement,
          callback: function($$v) {
            _vm.$set(_vm.cargoDoc, "portRequirement", $$v)
          },
          expression: "cargoDoc.portRequirement"
        }
      }),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "line-height": "16px",
            "margin-top": "5px",
            cursor: "pointer"
          },
          on: {
            click: function($event) {
              return _vm.downloadAttachment(
                _vm.cargoDoc.regionWarehouseMappingUuid
              )
            }
          }
        },
        [
          _c("i", {
            staticClass: "el-icon-paperclip",
            staticStyle: { "font-size": "16px" }
          }),
          _c(
            "div",
            {
              staticStyle: {
                "font-size": "12px",
                "text-decoration": "underline",
                color: "blue"
              }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("SystemMaintenance.PortRequirementsRelatedDocuments")
                )
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }